import { useEffect, useReducer, useState } from "react";
import { Container } from "@sainsburys-tech/luna-grid";
import { Pagination } from "@sainsburys-tech/luna-pagination";
import {
  errorToast,
  successToast,
} from "../../../../Service-Utils/toastMessage";
import * as CONSTANTS from "../../../../Constants/index";
import {
  initialState,
  reducer,
} from "../../../../Redux/Reducers/paginationReducer";
import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import { useGetApi } from "../../../../Redux/Hooks/useGetApi";
import EditableGridLuna from "../../../SharedComponents/EditableTable";
import { usePostApiRequest } from "../../../../Redux/Hooks/usePostApi";
import CustomToast from "../../../SharedComponents/CustomToast";
import LoadingIndicator from "../../../Loading";
import {
  ContainerTypeMaintenance,
  PayloadContainerTypeMaintenance,
} from "../../../../Types/containerTypeMaintenanceType";
import { useSelector } from "react-redux";
import { setResponseMessage } from "../../../../helpers/messageHelper";
import DuTypePopupDelete from "../../Delete-DuType/duTypeModalDelete";
import { storeFilter } from "../../../../Redux/Actions/filterActions";
import { filterPayloadType } from "../../../../Types/filterPayloadType";
import store from "../../../../Store/store";
import { emptyEditTablePayload } from "../../../../Redux/Actions/editTableActions";
import { getData } from "../../../../Service-Utils/autoCompleteHelper";
import { PopupFormatter } from "../../../SharedComponents/PopupHelper";
import {
  emptyStoreEditPayload,
  storeEditPayload,
} from "../../../../Redux/Actions/popupActions";
import { iInitialStateDuType } from "../../../../Interfaces/IDuType";
import { consolelog } from "../../../../helpers/consolelog";

type editPayloadType = {
  id: string;
  payload: PayloadContainerTypeMaintenance;
};
const DataTable = (props: ContainerTypeMaintenance) => {
  const [isError, setIsError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState<string>();
  const [rowId, setRowId] = useState<string>();
  const [operationType, setOperationType] = useState<string>();
  const [editPayload, setEditPayload] = useState<editPayloadType>();
  const [{ queryPageIndex, skip, queryPageSize, totalCount }, dispatch] =
    useReducer(reducer, initialState);
  const {
    data: filter,
    parentName,
    selectedMenu,
    createPopupName,
    deletePopupName,
    searchPageReset,
  } = useSelector((state: any) => state.filterReducer.data);
  const payload = useSelector((state: any) => state.popupReducer.data);

  const searchPayload = useSelector((state: any) => state.searchReducer);
  consolelog("searchPayload", searchPayload);

  //For update
  const paramsPorPost = {
    onSuccess(result: any) {
      onSuccess(result);
    },
    onError(error: any) {
      onError(error);
    },
  };
  const {
    mutate,
    isLoading: isMutateLoading,
    isSuccess: isMutateSuccess,
  } = usePostApiRequest(paramsPorPost);
  //For update

  const onSave = (editableData: any) => {
    consolelog(`Got editable data ${editableData.ContainerName}`);
    props.toggleSearchPanel(false);
    const payLoad: PayloadContainerTypeMaintenance = {
      ContainerName: editableData.ContainerName,
      ContainerType: editableData.ContainerType,
      Description: editableData.Description,
      FullHeight: editableData.FullHeight,
      FullLength: editableData.FullLength,
      FullWidth: editableData.FullWidth,
      Volume: editableData.Volume,
      Weight: editableData.Weight,
      WeightCap: editableData.WeightCap,
      MinPickVolume: editableData.MinPickVolume,
      MaxPickVolume: editableData.MaxPickVolume,
      LPIndicator: editableData.LpIndicator ? true : false,
      MLPIndicator: editableData.MlpIndicator ? true : false,
      MUIndicator: editableData.MuIndicator ? true : false,
      IsLinkableContainer: editableData.IsLinkableContainer ? true : false,
      LegacyContainerDetails: editableData.LegacyContainerDetails,
      LinkedContainers: editableData.MlpIndicator
        ? editableData.LinkedContainers
        : [],
      //Source: UI_CONSTANTS.LDMUI,
    };

    setEditPayload({ id: editableData.Id, payload: payLoad });
  };

  useEffect(() => {
    //For Add
    let headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    if (
      payload !== null &&
      payload !== undefined &&
      payload.addPayload !== null &&
      payload.addPayload !== undefined
    ) {
      payload.addPayload.id = "test";
      const params = {
        service: endpoints.createDuTpe(),
        method: "post",
        payload: payload.addPayload,
        headers: headers,
      };
      mutate(params);
      payload.addPayload = null;
      setOperationType("CreateDuType");
      store.dispatch(emptyEditTablePayload());
    }

    //For Edit
    if (
      editPayload != null &&
      editPayload !== undefined &&
      editPayload.id !== ""
    ) {
      const params = {
        service: endpoints.updateDuTypeByIdx(editPayload.id),
        method: "PATCH",
        payload: editPayload.payload,
        headers: headers,
      };
      mutate(params);
      setOperationType("EditDuType");
      editPayload.id = "";
      store.dispatch(emptyEditTablePayload());
    }

    //For Delete
    if (
      payload !== null &&
      payload !== undefined &&
      payload.deletePayload !== null &&
      payload.deletePayload !== undefined
    ) {
      const params = {
        service: endpoints.deleteDuType(payload.deletePayload),
        method: "delete",
        payload: null,
        headers: headers,
      };
      mutate(params);
      payload.deletePayload = null;
      setOperationType("DeleteDuType");
      store.dispatch(emptyEditTablePayload());
    }

    if (isMutateSuccess && !isError && operationType !== "") {
      successToast(setResponseMessage(operationType));
      setOperationType("");
      refetch();
    }
  }, [payload, isMutateSuccess, isError, editPayload, operationType]);

  const onEdit = (isPanelVisible: boolean) => {
    props.toggleSearchPanel(isPanelVisible);
  };
  const onSuccess = (data: any) => {
    if (data.isAxiosError) {
      errorToast(
        <CustomToast 
          heading={data?.response?.data?.error?.code}
          message={data?.response?.data?.error?.message}
        />
      );
      setIsError(true);
    } else if (data.status === 200 || data.status === 204) {
      setIsError(false);
    } else {
      setIsError(false);
    }
  };
  const onError = (error: any) => {
    consolelog("onError callback", error);
  };
  const params = {
    service: props.service,
    skip: skip,
    take: queryPageSize,
    isEnabled: true,
    filter: filter,
    refetchOnWindowFocus: false,
    isPaginationRequired: true,
    key: ``,
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onSuccess(result);
    },
  };

  const { data: apiResponse, isLoading, refetch } = useGetApi(params);

  useEffect(() => {
    const getResponse = async () => {
      if (searchPayload?.data !== null && searchPayload?.data?.value !== "") {
        let value = await getData(
          searchPayload?.data?.apiPath,
          searchPayload?.data?.filter,
          searchPayload?.data?.enabled,
          0,
          10,
          searchPayload?.data?.key
        );
        let data = value.length > 0 ? value[0]?.data : iInitialStateDuType;
        data.ContainerType = searchPayload?.data?.value;
        let newPayload = PopupFormatter(parentName, selectedMenu, data);
        store.dispatch(
          storeEditPayload({
            editPayload: newPayload,
            id: value.Id,
            selectedMenu: selectedMenu,
          })
        );
      } else {
        store.dispatch(emptyStoreEditPayload());
      }
    };
    getResponse();
  }, [searchPayload?.data?.filter]);

  useEffect(() => {
    //let ispageIndex = searchPageReset
    if (
      searchPageReset === "searchQueryPageReset" ||
      searchPageReset === "fullPageReset"
    ) {
      if (apiResponse?.data?.["@odata.count"] > 0) {
        dispatch({
          type: CONSTANTS.SEARCH_PAGE_RESET,
          payload: apiResponse?.data["@odata.count"],
        });
        let filterPayload: filterPayloadType = {
          data: searchPageReset === "fullPageReset" ? "" : filter,
          isDirectQuery: true,
          codeScreen: "",
          selectedMenu: selectedMenu,
          parentName: parentName,
          createPopupName,
          deletePopupName,
          searchPageReset: "",
          description: undefined,
          nestedSearchId: undefined,
          previousParentName: undefined,
          previousQueryData: undefined,
          searchId: undefined,
        };
        store.dispatch(storeFilter(filterPayload));
      }
    } else {
      if (apiResponse?.data?.["@odata.count"] > 0) {
        dispatch({
          type: CONSTANTS.TOTAL_COUNT_CHANGED,
          payload: apiResponse?.data["@odata.count"],
        });
      }
    }
  }, [apiResponse?.data?.value, apiResponse?.data?.["@odata.count"]]);

  function modifiyDescription(item: any, index: any, arr: any) {
    item.FamilyGroup = `${item.FamilyGroup}`;
    arr[index] = item;
  }

  useEffect(() => {
    if (props.isColumnMerge) {
      if (apiResponse?.data?.["@odata.count"] > 0) {
        let x = apiResponse?.data?.value.forEach(modifiyDescription);
      }
    }
  }, [apiResponse?.data?.value]);

  const errorMsg = (msg?: any) => {
    if (!isLoading) {
      consolelog("Error:", msg);
      return <div style={{ color: "red" }}>{msg}</div>;
    }
    return "";
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const onDelete = (editableData: any) => {
    setRowId(editableData.Id);
    setIsModalOpen(true);
  };
  return (
    <>
      {!isLoading && apiResponse?.data?.value ? (
        <>
          <EditableGridLuna
            data={apiResponse?.data?.value}
            columnDeffs={props.columnDefinition}
            rowKey="ContainerType,ContainerName,CustomerType,"
            tableName="DuType"
            onSave={onSave}
            onEdit={onEdit}
            onDelete={onDelete}
            isSortable={false}
          />
          {apiResponse?.data?.["@odata.count"] > 0 ? (
            <>
              <hr />
              <Container>
                <div style={{ float: "right" }}>
                  <Pagination
                    showFirstAndLast
                    current={queryPageIndex}
                    total={Math.ceil(totalCount / queryPageSize)}
                    onChange={(page: any, e: any) => {
                      e.preventDefault();
                      dispatch({ type: CONSTANTS.PAGE_CHANGED, payload: page });
                    }}
                    createHref={(page: any) => `/${page}`}
                  />
                </div>
              </Container>
              <hr />
              <Container className="marginTop4"> </Container>
              <hr />
            </>
          ) : (
            <>{!isError && errorMsg(CONSTANTS.ERROR_MESSAGES.noRecordsFound)}</>
          )}
        </>
      ) : (
        errorMsg()
      )}
      {(isLoading || isMutateLoading) && <LoadingIndicator />}
      <CustomToast />

      {isModalOpen && deletePopupName === "duTypeDeleteManagement" && (
        <DuTypePopupDelete
          isOpen={isModalOpen}
          title={"Delete"}
          handleClose={handleClose}
          Id={rowId}
        />
      )}
    </>
  );
};

export default DataTable;
